export default __webpack_public_path__ + "static/media/5h.5a72f855.png";